import nextInspirationsApi from '@features/api/nextApiService/nextInspirationsApi';
import { TInspirationsTypesSlug } from '@features/cms/typescript';
const getArticles = async (limit: number, slug: TInspirationsTypesSlug) => {
  const nextApi = nextInspirationsApi;
  const articlesTags = await nextApi.getArticles(limit, slug);
  return articlesTags;
};
export default getArticles;